import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ScrollBar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { Link, IndexLink } from 'react-router';
import * as routes from '../constants/routesNames';
import { isMobile } from '../../tools/mobileCheck';
import { I18n } from 'react-redux-i18n';

class BasePage extends Component {
  renderContent() {
    return (
      <div id="base-content">
        <div id="base-header">
          <IndexLink to={routes.HOMEPAGE}>
            <img
              className="logo"
              src={require('../assets/images/logo_f_white.svg')}
            />
          </IndexLink>
        </div>
        <div id="base-body">{this.props.children}</div>
      </div>
    );
  }

  render() {
    const contact_link_text = I18n.t('base_page.contact_link_text');

    return (
      <div id="base-page">
        {isMobile() ? (
          <div>{this.renderContent()}</div>
        ) : (
          <ScrollBar>
            {this.renderContent()}
            <div id="contact-link">
              <Link to={routes.CONTACT}>{contact_link_text}</Link>
            </div>
          </ScrollBar>
        )}
      </div>
    );
  }
}

BasePage.propTypes = {
  children: PropTypes.element
};

export default BasePage;



// WEBPACK FOOTER //
// ./src/components/BasePage.js